module.exports = __webpack_public_path__ + "img/mother.cc11bd7c.png";